import { Observer } from '@xing-com/crate-communication-in-view';
import type { JobTeaserVisibleJobFragment } from '@xing-com/crate-jobs-graphql';
import {
  JobsSectionCarousel,
  SimilarJobsSkeleton,
} from '@xing-com/crate-startpage-logged-out-jobs-section-package';

import { SimilarJob } from './similar-job';
import { useSimilarJobs } from './use-similar-jobs';

export const JobsSection: React.FC = () => {
  const { isLoading, recommendations } = useSimilarJobs();
  const slugList = recommendations?.map(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (item) => (item.job as JobTeaserVisibleJobFragment).slug
  );

  if (isLoading) {
    return <SimilarJobsSkeleton />;
  }

  return (
    <Observer>
      <JobsSectionCarousel>
        {recommendations?.map((recommendation, index) => (
          <SimilarJob
            key={recommendation.position}
            recommendation={recommendation}
            slugList={slugList}
            index={index}
          />
        ))}
      </JobsSectionCarousel>
    </Observer>
  );
};
